import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngrx/store';

import {ProgrammingEventService} from '../services';

@Pipe({
  name: 'distinctProxies'
})
export class DistinctProxiesPipe implements PipeTransform {

  constructor(
    private automationEvent: ProgrammingEventService,
    private store: Store<any>
  ) { }

  transform(items: any): Array<any> {
    let foundProxies = new Set<string>();

    items.forEach(item => {
      if (!foundProxies.has(item.proxy)) {
        foundProxies.add(item.proxy);
      }
    });

    return new Array<any>(foundProxies);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/distinct-proxies.pipe.ts